import { useMutation, useQuery } from "@apollo/client";
import {
  CoinType,
  getListInventoriesGQL,
  Inventory,
  InventoryCost,
  InventoryStatus,
  purchaseInventoryGQL,
} from "@onmo/graphql/graphql";
import { Query } from "@onmo/graphql/legacyGraphql";

export const getInventoryCost = (cost?: InventoryCost[]) => {
  const spendableGzTokens = cost?.find(
    (c) => c.coinType === CoinType.SpendableGzTokens,
  );

  if (!spendableGzTokens) return undefined;
  return {
    coinType: spendableGzTokens.coinType,
    amount: spendableGzTokens.amount,
  };
};

// get list of free Avatars
export const useFetchFreeAvatars = () => {
  const { data, loading, error } = useQuery<Query>(getListInventoriesGQL, {
    variables: {
      input: {
        page: {
          limit: 9,
          offset: 0,
        },
        filters: {
          restrictToFree: true,
          restrictToItems: true,
          categories: ["AVATAR"],
          status: [InventoryStatus.Available, InventoryStatus.Restricted],
        },
      },
    },
  });

  return {
    freeAvatars: data?.inventories?.items || [],
    total: data?.inventories?.totalCount || 0,
    loading,
    error,
  };
};

export const usePurchaseInventory = () => {
  const [purchaseInventoryAction] = useMutation(purchaseInventoryGQL);

  //purchase avatar/bundle function
  const purchaseInventory = async (inventory: Inventory) => {
    try {
      const result = await purchaseInventoryAction({
        variables: {
          input: {
            applyImmediately: inventory.applyImmediately,
            inventoryId: inventory.id,
            inventoryCost: getInventoryCost(
              inventory?.costs as InventoryCost[],
            ),
          },
        },
      });

      return result;
    } catch (error) {
      console.error(error);
    }
  };

  return purchaseInventory;
};
